import { createMatchSelector } from '@client/selectors/helpers/router';

export const hasFooterSelector = createMatchSelector({
  path: [
    '/profile',
    '/artists/:artistId',
    '/hosts/:venueId',
    '/about-us',
    '/home',
    '/for-artists-and-hosts',
    '/for-hosts',
    '/connect/:showCallId',
    '/contact-us',
    '/shows/:showId',
    '/shows',
    '/o/:jwt',
  ],
  exact: true,
});
